import { useEffect } from 'react';
import type { CoverDoc } from 'fym-shared/src/music24/coverDoc';
import { browserCoverStorage, writePublicCover } from './publicCoverStore';

/** The wait after the last change before the design goes to the storage of the browser. */
export const PUBLIC_COVER_SAVE_DELAY_MS = 400;

/**
 * Keeps the design of the public tool in this browser (`m24CoverMakerDoc`, spec §2): the document
 * and the two fields, a short time after each change, and at once when the page goes away. Nothing
 * goes to the server before the download.
 */
export function usePublicCoverPersist(cover: { doc: CoverDoc; title: string; artist: string }): void {
  const { doc, title, artist } = cover;
  useEffect(() => {
    const save = (): void => writePublicCover(browserCoverStorage(), { doc, title, artist });
    const timer = window.setTimeout(save, PUBLIC_COVER_SAVE_DELAY_MS);
    window.addEventListener('pagehide', save);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('pagehide', save);
    };
  }, [artist, doc, title]);
}
